import { gql } from '@apollo/client'

export const REVIEW_ACTIVITIES_LIST_QUERY = gql`
  query REVIEW_ACTIVITIES_LIST_QUERY($filter: LogFilterInput!) {
    logs(filter: $filter) {
      data {
        id
        actionType
        createdAt
        entityId
        entityType
        metadata {
          fileName
          fileUrl
          fileContentType
          comment
        }
        user {
          id
          firstName
          lastName
          avatarUrl
        }
      }
    }
  }
`

export const REVIEWS_TO_APPROVE_QUERY = gql`
  query REVIEWS_TO_APPROVE_QUERY {
    reviewsToApprove {
      data {
        id
        planId
        planObjectiveId
        planActionId
        planKPIId
        startPeriod
        endPeriodAt
        dueAt
        scheduledReview {
          id
          repeating
          scheduledReviewers {
            id
            userId
            positionId
            reviewDate {
              end
              value
              date
              period
            }
            user {
              id
              firstName
              lastName
              avatarUrl
            }
            position {
              id
              description
            }
          }
        }
        status
        values {
          goals
          doWell
          doBetter
        }
        fieldValueMap {
          fieldId
          fieldValueId
          fieldValue
        }
        planName
        planItemName
        approvers {
          userId
          positionId
        }
        approvedAt
      }
    }
  }
`
